import bService from '@/api/base-api'
import { CONTRACT_MANAGER_URL } from '@/configs/service-url'

const detail = async (hotelId, remarkType) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/remark/${remarkType}`
  const result = await bService.get(url)

  return result
}

const update = async (hotelId, remarkType, data) => {
  const hotelUrl = CONTRACT_MANAGER_URL.HOTEL
  const url = `${hotelUrl}/${hotelId}/remark/${remarkType}`
  const result = await bService.put(url, data)

  return result
}

export default {
  detail,
  update
}
